<template>
  <div class="b-card-container">
    <div class="bc-header-container">
      <div class="bc-header">Sensor Detail</div>
      <div class="bc-header">Total: {{ sensors.length }}</div>
    </div>
    <div class="bc-table-container">
      <div class="bct-header-container">
        <div class="bct-header">Type</div>
        <div class="bct-header">Serial</div>
        <div class="bct-header">Location</div>
        <div class="bct-header">Battery</div>
        <div class="bct-header">Signal</div>
        <div v-if="adminRole !== 'viewer' && isSmacAdmin" class="bct-icon-header" />
        <div class="bct-icon-header" />
      </div>
      <div class="bct-body-container">
        <div v-for="s in sensors" :key="s.serialNumber" class="bct-row-container">
          <div class="bct-body">
            {{ sensorType(s.sensorLabel) }}
            <button
              v-if="s.imageUrl && isSmacAdmin"
              type="button"
              @click="() => openImage(s.imageUrl)"
              class="ml-1"
            >
              <span
                v-if="s.correctPlacement === 'Correct'"
                class="icon-luc-Camera sac__font-14 f-green"
              />
              <span
                v-else-if="s.correctPlacement === 'Incorrect'"
                class="icon-luc-Camera sac__font-14 tomato"
              />
              <span
                v-else-if="s.correctPlacement === 'Unusable'"
                class="icon-luc-Camera sac__font-14 f-yellow"
              />
              <span v-else class="icon-luc-Camera" />
            </button>
            <div v-if="s.sensorLabel === 'Attic'" class="water-install">
              <span class="sac__font-8"> Monitoring A/C: {{ s.acRelated ? 'Y' : 'N' }} </span>
              <span class="sac__font-8"> Drain Pan: {{ s.drainPan === 'Y' ? 'Y' : 'N' }} </span>
            </div>
          </div>
          <div class="bct-body">
            {{ `...${s.serialNumber.slice(15, 22)}` || '--' }}
          </div>
          <div class="bct-body">
            {{ s.location || '--' }}
            <div v-if="s.sensorLabel === 'Attic'" class="water-install">
              <span class="sac__font-8">
                Water Riser: {{ s.accessory === 'Riser' ? 'Y' : 'N' }}
              </span>
            </div>
          </div>
          <div :class="[determineBatteryStatus(s.status), 'bct-body']">
            {{ batteryStatus(s.status) }}
            <div class="bct-tooltip">
              Last Battery Status: {{ lastBatteryStatus(s.status) }}
              <br />
              <span v-if="s.status && s.status.lastBatteryState">
                On {{ formatToolTipDate(s.status.lastBatteryUpdate) }}
              </span>
              <br />
              <br />
              <span v-if="s.batteryUpdate">
                Last Battery Replace: <br />
                {{ formatToolTipDate(s.batteryUpdate) }}
              </span>
            </div>
          </div>
          <div :class="[determineDeviceStatus(s.status), 'bct-body']">
            {{ deviceStatus(s.status) }}
            <!-- if hub is online, there is an active leak alert, and the leak sensor is offline -->
            {{
              hubs.filter((hub) => s.uid == hub.uId && hub.onlineStatus).length
                && s.status
                && s.status.sensorRatio === 0
                && alertsTabTableData.filter(
                  (alert) => s.deviceId === alert.did
                    && s.uid == alert.uid
                    && alert.type.includes('Water'),
                ).length
                ? 'Possibly Flooded'
                : ''
            }}
          </div>
          <div v-if="adminRole !== 'viewer' && isSmacAdmin" class="bct-icon-container">
            <button type="button" @click="toggleActionModal(true, 'replace-sensor', s)">
              <img src="@shared/assets/img/general/svg/repeat.svg" alt="edit" class="edit-sensor" />
            </button>
          </div>
          <div class="bct-icon-container">
            <button
              type="button"
              class="filter-row-edit"
              @click="toggleActionModal(true, 'edit-sensor-details', s)"
            >
              <img
                src="@shared/assets/img/general/more-vertical.svg"
                alt="edit"
                class="edit-sensor"
              />
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import customerDetailMixin from '@shared/mixins/customerDetailMixin';

export default {
  name: 'SensorDetail',
  mixins: [customerDetailMixin],
  data() {
    return {
      sensorLocation: '',
      serialNumber: '',
    };
  },
  methods: {
    editSensorLocation(sensor) {
      this.sensorLocation = sensor.location;
      this.serialNumber = sensor.serialNumber;
      const updatedSensors = this.sensors.map((s) => {
        s.editOn = s.serialNumber === sensor.serialNumber;
        return s;
      });
      this.$store.dispatch('changeCustomerDetailValue', {
        field: 'sensors',
        value: updatedSensors,
      });
    },
    openImage(image) {
      const location = {
        path: '/image',
        query: { src: image },
      };
      const route = this.$router.resolve(location);
      const newTab = window.open(route.href, '_blank');
      if (!newTab) {
        this.$router.push(location);
        return;
      }
      newTab.opener = null;
    },
    updateSensorLocation(sn) {
      this.$store.dispatch('updateSensor', {
        serialNumber: sn,
        location: this.sensorLocation,
      });
    },
    resetSensorLocation() {
      const updatedSensors = this.sensors.map((s) => {
        s.editOn = false;
        return s;
      });
      this.$store.dispatch('changeCustomerDetailValue', {
        field: 'sensors',
        value: updatedSensors,
      });
    },
    formatToolTipDate(date) {
      return moment(date).format('DD MMM YYYY');
    },
  },
};
</script>

<style lang="scss" scoped>
.water-install {
  display: flex;
  flex-direction: column;
}
.edit-sensor {
  width: 18px;
  height: 18px;
}
</style>
